var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pane-tag", attrs: { id: "pane-tag" } }, [
    _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "flex-direction": "column",
          "align-items": "end"
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "map-pane-tag",
            class: {
              "map-pane-tag--active": _vm.options.is_on_map,
              "map-pane-tag--no_data_pink":
                !_vm.options.has_layer &&
                !_vm.options.is_loading &&
                _vm.tag_config.no_data === "pink"
            }
          },
          [_c("div", [_vm._v(_vm._s(_vm.options.text))])]
        ),
        _vm._v(" "),
        _vm.options.name === "id_81"
          ? _c(
              "div",
              {
                staticClass: "map-pane-tag",
                class: {
                  "map-pane-tag--active": _vm.options.is_on_map,
                  "map-pane-tag--no_data_pink":
                    !_vm.options.has_layer &&
                    !_vm.options.is_loading &&
                    _vm.tag_config.no_data === "pink"
                }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s("hPa: " + this.dropsonde.hPa) +
                    "\n        "
                )
              ]
            )
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _vm.forecast_text
      ? _c("span", {
          staticClass: "data-time-tag",
          domProps: { innerHTML: _vm._s(_vm.forecast_text) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }